/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { initFancyFirebase, fancyConfig } from '@touchplan/fancy-referencer';
import { FancyFirebaseState } from 'src/app/common/fancy-firebase/services/fancy-firebase-state.service';
import { DynamicFlagTypes } from '@touchplan/feature-flags';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { environment } from 'src/environments/environment-variables';
import { fancyDatabase } from '@touchplan/client-firebase';

export function frontendInitFancyFirebase(
	fancyFirebaseState: FancyFirebaseState,
	featureFlagManager: FeatureFlagManager
) {
	featureFlagManager.getFlag$(DynamicFlagTypes.PROJECT_PARTITIONING_ENABLED).subscribe((enabled) => {
		fancyConfig.enablePartitioning = <boolean>enabled;
	});
	initFancyFirebase(fancyFirebaseState, fancyDatabase, {
		firebaseDatabaseUrl: environment.firebase.databaseURL,
		firebaseRefUrl: environment.refUrl,
		enablePartitioning: featureFlagManager.getFlag(DynamicFlagTypes.PROJECT_PARTITIONING_ENABLED),
	});
}
